import { watch } from 'vue'
import { type TRedirect } from '~/types/response-types'
import { type TPage } from '~/types/page-types'
import { usePageStore } from '~/store/page'

const getProgramName = (data) => {
  if (!data?.belongs_to || !Array.isArray(data.belongs_to)) {
    return undefined
  }

  return data.belongs_to
    .filter(btItem => btItem.collection === 'program_page')
    .map((btItem) => {
      // Optie 1: Alleen de accolades verwijderen
      // Dit maakt er "Tussen Kunst en Kitsch" van
      return btItem.item.slug
    })
    .join(', ')
}

export const useNPOTag = (data: TPage | TRedirect) => {
  const pageStore = usePageStore()
  // const program = data?.collection === 'program_page' ? data.slug : ''
  let tempQueue: any[] = []

  if (data) {
    const trigger = () => {
      if (pageStore.getNpoTagLoaded) {
        tempQueue.forEach((item) => {
          sendEvent(item)
        })
        tempQueue = []
      }
    }

    const sendEvent = (data) => {
      const tag = npotag.newTag(
        // Set properties shared by all events
        {
          brand: 'avrotros',
          brand_id: 630226,
          platform: 'site'
        },
        [
          npotag.newGovoltePlugin(),
          npotag.newConsoleLoggerPlugin()
        ])

      const trackerData = {
        page: data.title || 'unknown',
        environment: 'prod',
        content_context_id: '',
        broadcasters: 'avrotros',
        program: getProgramName(data) || '',
        custom_label1: ''
      }

      if (data.collection === 'program_page') {
        trackerData.program = getProgramName(data) || data.slug
      }

      const tracker = npotag.newPageTracker(tag, trackerData)
      console.log('✔ NPO tag tracked with Govolte!')
      console.log('ℹ trackerData:', trackerData)
      tracker.pageView()
    }

    if (!pageStore.getNpoTagLoaded) {
      tempQueue.push({ ...data })

      watch(() => pageStore.$state.npoTagLoaded, trigger)
    } else {
      sendEvent(data)
    }
  }
}
